"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAmountOperatorString = exports.toAmountOperator = exports.AmountOperator = void 0;
var AmountOperator;
(function (AmountOperator) {
    AmountOperator[AmountOperator["Lt"] = 0] = "Lt";
    AmountOperator[AmountOperator["LtEq"] = 1] = "LtEq";
    AmountOperator[AmountOperator["Eq"] = 2] = "Eq";
    AmountOperator[AmountOperator["GtEq"] = 3] = "GtEq";
    AmountOperator[AmountOperator["Gt"] = 4] = "Gt";
})(AmountOperator = exports.AmountOperator || (exports.AmountOperator = {}));
const toAmountOperator = (operator) => ({
    '<': AmountOperator.Lt,
    '<=': AmountOperator.LtEq,
    '=': AmountOperator.Eq,
    '>=': AmountOperator.GtEq,
    '>': AmountOperator.Gt,
}[operator] ?? operator);
exports.toAmountOperator = toAmountOperator;
const toAmountOperatorString = (operator) => ({
    [AmountOperator.Lt]: '<',
    [AmountOperator.LtEq]: '<=',
    [AmountOperator.Eq]: '=',
    [AmountOperator.GtEq]: '>=',
    [AmountOperator.Gt]: '>',
}[operator] ?? operator);
exports.toAmountOperatorString = toAmountOperatorString;
//# sourceMappingURL=amountOperator.js.map